'use client';
import React from 'react';
import { NewsCardItem } from '../NewsWithTabs/NewsCardItem';
import styled from '@benzinga/themetron';
import { WordpressPost } from '@benzinga/content-manager';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { Icon } from '@benzinga/core-ui';

export interface NewsCardsBlockProps {
  attrs?: {
    data: {
      title: string;
      article?: WordpressPost[];
    };
  };
}

export const NewsCardsBlock = ({ attrs }: NewsCardsBlockProps) => {
  const [expandList, setExpandList] = React.useState<boolean>(true);

  const handleClick = () => {
    setExpandList(!expandList);
  };

  if (!attrs?.data?.article || !Array.isArray(attrs.data.article)) return null;

  return (
    <BlockWrapper>
      <div className="card-header">
        <h3>{attrs.data.title}</h3>
        <div className="icon-wrap" onClick={handleClick}>
          {expandList ? (
            <Icon className="chevron-up" icon={faChevronUp} strokeWidth={3} />
          ) : (
            <Icon className="chevron-down" icon={faChevronDown} strokeWidth={3} />
          )}
        </div>
      </div>
      {expandList && (
        <div className="cards-wrapper">
          {attrs?.data.article.map(card => (
            <NewsCardItem card={card} key={card.id} variant="list" />
          ))}
        </div>
      )}
    </BlockWrapper>
  );
};

const BlockWrapper = styled.div`
  border: 1px solid #ceddf2;
  border-radius: 4px;
  margin-bottom: 1rem;
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: #e1ebfa;
    h3 {
      font-weight: 600;
      color: #283d59;
      font-size: 16px;
    }
    .icon-wrap {
      cursor: pointer;
    }
  }
  .cards-wrapper {
    .list {
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
`;
